import React from 'react';
import Link from 'next/link';

import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import WebpImage from '@r1-frontend/ui-react/components/WebpImage';

import * as ST from './styled';

const gradeHelpGirl = '/static/images/grades/grade-help-girl';
const SUPPORT_MAIL = 'mailto:help@domru.ru';

const GradeHelp = () => {
    return (
        <ST.Wrapper>
            <ST.ContentWrapper>
                <H3
                    as={'h2'}
                    data-test='grade-help-label'
                    $withIndent={false}
                >
                    Столкнулись с&nbsp;проблемой?
                </H3>
                <ST.TextWrapper>
                    <Paragraph4 data-test='grade-help-text'>
                        Обязательно поделитесь с&nbsp;нами подробностями&nbsp;&mdash; поможем разобраться
                        и&nbsp;возьмём ваш опыт на&nbsp;вооружение. Хвалите, ругайте, предлагайте&nbsp;&mdash;
                        каждый отзыв помогает нам становиться лучше для вас.&nbsp;
                        <Link href={SUPPORT_MAIL} prefetch={false} passHref={false}>
                            <ST.TextLink href={SUPPORT_MAIL}>
                                {'Написать на почту'}
                            </ST.TextLink>
                        </Link>
                    </Paragraph4>
                </ST.TextWrapper>
                <WebpImage urlWebp={`${gradeHelpGirl}.webp`}>
                    <ST.ImageGirl data-test='grade-help-image' src={`${gradeHelpGirl}.png`}/>
                </WebpImage>
            </ST.ContentWrapper>

            <ST.ContentWrapper>
                <H3
                    as={'h2'}
                    data-test='grade-help-review-label'
                    $withIndent={false}
                >
                    Для чего мы&nbsp;просим вас оставить отзыв
                </H3>
                <Paragraph4 data-test='grade-help-review-text'>
                    Обратная связь очень важна. Мы&nbsp;учитываем ваши пожелания и&nbsp;потребности, чтобы повышать
                    качество услуг и&nbsp;стабильность связи. Ещё отзывы помогают другим людям оценить надёжность
                    интернет-провайдера и&nbsp;сделать выбор.
                </Paragraph4>
                <Paragraph4>
                    Отзывы содержат критику&nbsp;&mdash; это хорошо. Она помогает нам работать над своими недостатками
                    и&nbsp;становиться лучше.
                </Paragraph4>
            </ST.ContentWrapper>
        </ST.Wrapper>
    );
};

export default GradeHelp;
